import React from 'react';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {
  SaleTypeCssClasses,
  SaleTypeTitles,
  ChannelCssClasses,
  ChannelTitles,
} from '../../SalesUIHelpers';
import { Button } from 'react-bootstrap';

export function SaleTypeColumnFormatter(cellContent, row) {
  const ind = getSaleTypeIndex(cellContent);
  const indChannel = getChannelIndex(row.channel);
  function getSaleTypeIndex(saleType) {
    switch (saleType) {
      case 'ORDER':
        return 1;
      default:
        return 0;
    }
  }
  function getChannelIndex(channel) {
    switch (channel) {
      case 'INPERSON':
        return 0;
      case 'FACEBOOK':
        return 1;
      default:
        return 2;
    }
  }
  const getSaleTypeCell = (saleType, channel) => {
    if (saleType === 'ORDER')
      return (
        <span
          className={`label label-lg label-light-${SaleTypeCssClasses[ind]} label-inline`}
        >
          {SaleTypeTitles[ind]}
        </span>
      );
    else {
      return (
        <div>
          <OverlayTrigger
            placement='top'
            overlay={<Tooltip id={`tooltip-saleChannel`}>{channel}</Tooltip>}
          >
            <span
              className={`label label-lg label-light-${ChannelCssClasses[indChannel]} label-inline`}
            >
              {SaleTypeTitles[ind]}
            </span>
          </OverlayTrigger>
        </div>
      );
    }
  };

  return getSaleTypeCell(cellContent, row.channel);
}
